import * as React from "react";
import { BlogMetaPaper } from "../common/BlogMetaPaper";
import { MetaTitle } from "../common/MetaTitle";
import { usePersonalInformation } from "../../../../data/hooks/usePersonalInformation";
import { Avatar } from "../../../common/Avatar";
import { Box, Typography } from "@mui/material";

export function BlogMetaAuthor() {
  const personalInformation = usePersonalInformation();
  return (
    <BlogMetaPaper>
      <MetaTitle text="Author" />
      <Box sx={{ margin: "16px", justifyContent: "center", display: "flex" }}>
        <Avatar image={personalInformation.portrait} small />
      </Box>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        {personalInformation.thirdPersonAboutMe}
      </Typography>
    </BlogMetaPaper>
  );
}
